import { render, staticRenderFns } from "./ShipmentEditor.vue?vue&type=template&id=0ef0a775"
import script from "./ShipmentEditor.vue?vue&type=script&lang=js"
export * from "./ShipmentEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports